import './borrower_widget.scss';
import {
    CampaignServiceName,
    CUSTOMER_DETAILS_SERVICE_NAME,
    ToastNotificationServiceName,
    UserServiceName
} from "../../../utils/names/serviceNames";
import {IComponentController} from "angular";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import {User, UserGender} from "../../../users/model/User";
import {CustomerDetailsService} from "../../../customer_service/service/CustomerDetailService";
import {UserService} from "../../../users_service/service/user.service";
import {CONFIGURATION_INITIALIZER} from "../../../../initializers/ActiveBrandInitializer";
import {UserGranredAuthorityName} from "../../../router/const/AllPermitions";
import {UserView} from "../../../users/model/UserFilter";
import {CampaignToggle} from "../../../campaigns_service/model/CampaignToggle";
import {CampaignService} from "../../../campaigns_service/service/CampaignService";
import {ContactType} from "../../model/Contact";
import {Customer, FunnelStatusEnum} from "modules/customers/model/Customer";
import {CampaignType} from "modules/campaigns_service/model/CampaignType";


export class BorrowerWidget implements IComponentController {

    static instance = {
        controller: [
            CUSTOMER_DETAILS_SERVICE_NAME,
            '$mdDialog',
            ToastNotificationServiceName,
            UserServiceName,
            CampaignServiceName,
            BorrowerWidget
        ],
        template: require('./borrower_widget.html'),
        bindings: {
            "contact": "<"
        },
        transclude: {
            borrowerInfo: 'borrowerInfo'
        }
    };

    static wrapperInstanceFactory = (instance: any) => (Object.assign(instance, {
        bindings: {
            "contact": "<"
        },
    }));

    private contact: Customer & any;
    private calcConfigurations: any;
    private campaignToggles: CampaignToggle[];
    private userCampaignToggles: CampaignToggle[];
    private loInputDisabled: boolean = true;
    private originalCustomerEmployee: User;
    private allowTransferLoanOfficer: boolean;

    constructor(private customerDetailService: CustomerDetailsService,
                private $mdDialog: angular.material.IDialogService,
                private notificationService: ToastNotificationService,
                private employeeService: UserService,
                private campaignService: CampaignService) {
    }

    $onInit() {
        this.originalCustomerEmployee = this.contact.employee;
        this.contact.avatarUrl = this.getDefaultAvatarUrl(this.contact.gender);
        if (this.contact.type == ContactType.CUSTOMER) {
            this.fetchCalculationConfigurations();
        }
        this.fetchCampaignToggles();
        this.initTransferLoanOfficerAllowed();
    }

    private fetchCalculationConfigurations() {
        this.customerDetailService.findCustomerCalculationsConfiguration(this.contact.id)
            .then(resp => {
                if (resp.status === 200) {
                    this.calcConfigurations = resp.data;
                }
            });
    }

    private fetchCampaignToggles() {
        this.campaignService.fetchCustomerCampaignToggles(this.contact.id)
            .then(resp => {
                if (resp.status === 200) {
                    let campaignToggles = resp.data.filter(t => t.clientType === this.contact.type); // I need to refactor line bellow
                    let userCampaignToggles = resp.data.filter(t => t.type == CampaignType.EPO || t.type == CampaignType.TBD || t.type == CampaignType.OPPORTUNITY_SUMMARISING);
                    console.table([
                        resp.data, campaignToggles
                    ])
                    this.campaignToggles = campaignToggles;
                    this.userCampaignToggles = userCampaignToggles;
                }
            })
    }

    private initTransferLoanOfficerAllowed() {
        CONFIGURATION_INITIALIZER
            .getPrinciple()
            .then(principal => {
                this.allowTransferLoanOfficer = principal.userAccessLevels
                    .filter(featureAcces => featureAcces.status)
                    .some(featureAccess => featureAccess.authorityName === UserGranredAuthorityName.TRANSFER_LO);
            });
    }

    queryEmployee = (query: string) => {
        return this.employeeService.queryEmployee({
            userIds: [],
            branchesIds: [],
            showDeleted: true,
            showDisabled: false,
            view: UserView.AUTOCOMPLETE,
            query: query
        }).then((resp) => {
            if (resp.status === 200) {
                return resp.data;
            } else {
                this.notificationService.generateErrorMessage('Failed to fetch users information!')
            }
        })
    };

    showConfirmTransferDialog = (selectedLO: User) => {
        if (selectedLO && selectedLO.id != this.originalCustomerEmployee.id) {
            this.loInputDisabled = true;
            let confirm = this.getConfirmTransferCustomerToLO(selectedLO);
            this.$mdDialog.show(confirm).then(
                resp => {
                    this.employeeService.transferCustomersToEmployee(selectedLO, this.contact)
                        .then(
                            resp => this.originalCustomerEmployee = selectedLO,
                            () => this.notificationService.generateErrorMessage("Failed to change contact original LO")
                        )
                },
                () => {
                    this.contact.employee = this.originalCustomerEmployee;
                });
        }
    };

    private getConfirmTransferCustomerToLO(selectedLO: User) {
        return this.$mdDialog.confirm()
            .title(`Are you sure you want to transfer customer to the user?`)
            .textContent(`Customer is going to be reassigned to ${selectedLO.name}.`)
            .ok('Yes')
            .cancel('No Cancel');
    }


    changeLO = () => {
        this.loInputDisabled = false;
    };

    changeCustomerNewsSubscriptionStatus = () => {
        let selectedContact = this.contact;
        let status = selectedContact.subscribedForSendgridNews;
        this.customerDetailService.changeCustomerNewsSubscriptionStatus(
            selectedContact.id,
            selectedContact.subscribedForSendgridNews
        ).then(
            resp => {
                this.notificationService.generateSuccessMessage(
                    `Customer news subscription status has been updated successfully`
                );
                selectedContact.subscribedForSendgridNews = status;
            },
            () => {
                this.notificationService.generateErrorMessage(
                    `Failed to update customer news subscription status`
                );
                selectedContact.subscribedForSendgridNews = !status;
            }
        );
    };

    changeCustomerCalculationsStatus = (configuration) => {
        this.customerDetailService.changeCustomerCalculationsStatus(
            this.contact.id,
            configuration)
            .then(resp => this.notificationService.generateSuccessMessage(
                    `Opportunity search for the customer has been ${this.contact.isIncludedInPricingWork ? 'enabled' : 'disabled'}`
                )
            )
    };

    changeCustomerCampaignStatus = (configuration: CampaignToggle) => {
        this.campaignService.updateCampaignConfigurationToggle(this.contact.id, configuration)
            .then(resp => {
                if (resp.status !== 200) {
                    this.notificationService.generateErrorMessage('Failed to switch campaign toggle');
                }
            });
    };

    makeContactAvailableForUpdate = () => {
        this.customerDetailService.makeContactAvailableForUpdate(this.contact.id)
            .then(resp => this.contact.lastUpdated = resp.data);
    };

    getDefaultAvatarUrl = (gender: UserGender) => {
        let fileName;
        switch (gender) {
            case UserGender.FEMALE:
                fileName = 'default_Female.jpg';
                break;
            case UserGender.MALE:
                fileName = 'default_Male.jpg';
                break;
        }
        fileName = fileName ? fileName : 'default_customer.jpg';
        return '/app/images/avatar/' + fileName;
    };

    getIsTbdStatus = () => {
        return this.contact.funnelStatus === FunnelStatusEnum.PRE_APPROVED || this.contact.funnelStatus === FunnelStatusEnum.PRE_QUAL
    }
    getIsCampaignToggleDisabled = (campaignType: CampaignType): boolean => {
        if (this.contact.deleted) {
            return true;
        }
        const isTbdStatus = this.getIsTbdStatus();
        const isTbdCampaign = campaignType === CampaignType.TBD;
        const isActiveEmployee = this.contact.employee.isActive;

        if (isTbdStatus) {
            return !isTbdCampaign || !isActiveEmployee;
        } else {
            return isTbdCampaign || !isActiveEmployee;
        }
    }
    getIsCalculationToggleDisabled = () => {
        if (this.contact.deleted) {
            return true;
        }
        return this.getIsTbdStatus() || !this.contact.employee.isActive
    }

    restoreCustomer = (): void => {
        this.customerDetailService.restoreCustomer(this.contact.id)
    };
}
